import React, { Component } from 'react';
import ButtonComponent from "../../../shared/button/components/ButtonComponent";
import "../style/SelectCollection.scss";
import { Swiper, Pagination, Navigation } from 'swiper/dist/js/swiper.esm.js';
import ReactIdSwiperCustom from 'react-id-swiper/lib/ReactIdSwiper.custom';
import "react-id-swiper/lib/styles/scss/swiper.scss";
import axios from "axios";
import LoadingComponent from "../../../shared/loading/components/LoadingComponent";

class SelectCollectionBox extends Component {
    state = {
        collections: [],
        loading: true,
        noCollections: false
    };

    getCollections() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/short-collection/${this.props.seller}/`, this.headers)
            .then((response) => {
                this.setState({
                    collections: response.data,
                    loading: false
                })
                if(response.data.length === 0 ){
                  this.setState({ noCollections: true})
                }
            });
    }

    componentDidMount() {
        this.getCollections();
    }

    render() {

        if(this.state.loading) { return (<LoadingComponent />) }
        const settings = {
            Swiper,
            modules: [Pagination, Navigation],
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        return (
            <div className="select-collection">
                { this.state.collections.map( (collection, index) => {
                    return (
                        <div className="collection-box" key={index}>
                            <div className="slider-wrapper">
                                <ReactIdSwiperCustom {...settings} >
                                    { collection.products.map( (paths, index) => {
                                        return (
                                          <div key={index} className="image-wrapper">
                                            <img src={paths} alt="" />
                                          </div>
                                        )
                                    })}
                                </ReactIdSwiperCustom>
                            </div>
                            <div className="collection-name" >
                                <p>{ collection.name }</p>
                                <ButtonComponent type="navLink" linkTo={`/${this.props.seller}/collections/${collection.id}`}>
                                    {window.localStorage.getItem("user_type") === "buyer" ? (
                                        <>
                                        {collection.button}
                                        </>
                                    ):(
                                        <>
                                        view collection
                                        </>
                                    )}
                                </ButtonComponent>
                            </div>
                        </div>
                    )
                }) }
                {this.state.noCollections &&
                  <div className="no-collection">
                    THIS BRAND HAS NO<br/>
                  COLLECTION AVAILABLE<br/>
                    AT THIS TIME.
                    <p>The new collection is coming soon!</p>
                  </div>
                }
            </div>
        );
    }

}

export default SelectCollectionBox;
